<template>
  <!-- Content Wrapper. Contains page content -->
  <div id="content-wrap" class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <strong>
        {{this.$route.name.toUpperCase()}}
      </strong>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link  to="/"><i class="fa fa-dashboard"></i> Home</router-link></li>
        <li class="breadcrumb-item active"><b>{{this.$route.name}}</b></li>
      </ol>
      <br>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
export default {
  name: 'va-content-wrap',
  created () {
    $('body').addClass('skin-blue sidebar-mini').removeClass('login-page')
  }
}
</script>

<style>
.page-enter-active, .page-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.page-enter, .page-leave-to {
  opacity: 0;
}
.content-wrapper {
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// ContentWrap.vue?a2463a68